import React from "react";

export function useClickOutside<T extends HTMLElement = never>(
  handleClickOutside: () => void,
  watches: unknown[] = [],
): React.RefObject<T> {
  const ref = React.useRef<T>(null);

  function handleClick(e: Event) {
    const node = ref.current;

    if (
      !node
      || !e.target
      || node.contains(e.target as Node)
      // google's autocomplete items don't pass the node.contains check above
      || targetIsGoogleAcItem(node, e.target as Element)
    ) {
      return;
    }

    handleClickOutside();
  }

  React.useEffect(() => {
    // add when mounted
    document.addEventListener("mousedown", handleClick);

    // return function to be called when unmounted
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, watches);

  return ref;
}

function targetIsGoogleAcItem(_parent: Element, target: Element) {
  const classes = target.className.split(" ");
  return classes.includes("pac-item");
}
